// extracted by mini-css-extract-plugin
export var container = "_f9-1";
export var editor = "_f9-2";
export var resizable = "_f9-3";
export var wrapper = "_f9-0";